jQuery(function($) {
    
    /*************/
    /* VAR */
    /*************/
    var xx = 0;
    var l_window = parseInt($(window).width());
    var LARGEUR_MAX_MOBILE = 1024;
    if($("#submenu-js").length){
      var position_top_sub_menu = $("#submenu-js").offset().top;
    }


   var $bg_club = $('.SingleClub--bgnew');

    if ($( ".ClubTop-Intro" ).length) {

    var pos_fin_txt_pres_club;

    if(l_window > 767)
    {
    pos_fin_txt_pres_club = parseInt($('.ClubTop-Intro').offset().top + $('.ClubTop-Intro').height() + 50);
    $bg_club.height(pos_fin_txt_pres_club);
    }else{
      $bg_club.height('auto');
    }
    



      $( window ).resize(function() {
        if ($( ".ClubTop-Intro" ).length) {
          l_window = parseInt($(window).width());
          if(l_window > 767)
          {

           pos_fin_txt_pres_club = parseInt($('.ClubTop-Intro').offset().top + $('.ClubTop-Intro').height() + 50);
           $bg_club.height(pos_fin_txt_pres_club);

            }else{
            $bg_club.height('auto');
          }
          
        }
      });

    }

    /* **************************************************  */
  /* AUTEUR DU BACKGROUND EN FONCTION  du texte*/
  /* **************************************************  */





  /* **************************************************  */
  /* FILTRE SUR LES CLUBS // ATTENTION, ON NE PRENDS PAS LE SEARCH EN HAUT DANS LE MENU */
  /* **************************************************  */
    var number__found = $('.number__found');
    var $to_display = $('.ResultClubSearch');
    $to_display.hide();
  
    $( ".page-template-m_les_clubs .page-header .search-form" ).submit(function (evt) {

     
      var search_str = $('.page-header .search-field').val().toLowerCase();

      

      //find all .user-profile divs
      $('.LogoClub-Item')

      //find those that should be visible
      .filter(function() {
        return $(this).data('title').toLowerCase().indexOf( search_str ) > -1;

      })

      .show().addClass('so_show')

      .end().filter(':visible')

       .filter(function() {
          return $(this).data('title').toLowerCase().indexOf( search_str ) === -1;
        })

      .fadeOut().removeClass('so_show');

      number__found.text($('.OnlyItemClub.so_show').length);
      $('.ResultClubSearch strong').text(search_str);
      if(search_str != ''){
        $('.start_search').show();
         $to_display.slideDown();
      }else{
        $('.start_search').fadeOut();
         $to_display.slideUp();
      }

       evt.preventDefault();

  });


  /* END DATE FILTER */

    /* **************************************************  */
  /* GALLERIE PHOTO */
  /* **************************************************  */
    $('.gallery').featherlightGallery({closeIcon:'<i class="icon-close"></i>'});
    $('.gallery a').featherlightGallery({closeIcon:'<i class="icon-close"></i>'});
    
  $.featherlightGallery.prototype.afterContent = function() {
  var caption = this.$currentTarget.attr('title');
  this.$instance.find('.caption').remove();
  if(caption){
    $('<div class="caption">').html('<span>'+caption+'</span>').appendTo(this.$instance.find('.featherlight-content'));
  }
};



   /* **************************************************  */
  /* NICSELECT */
  /* **************************************************  */
  $('.to_nicedropdown-js').niceSelect();
  $('.js-special_sub_menu_mobile').on('change', function() {
     var href = this.value;
    scroll_to_section(href);
  });

  $('.js-special_to_redirect').on('change', function() {
     var href = this.value;
     document.location.href= href;
  });


   /*************/
    /* OUVERTURE / FERMETURE DU MENU */
    /*************/
    $('#menu-toggle').click(function(e){
          if($(this).attr('aria-expanded') == 'false'){
             $(this).find('.txt').text('Menu');
           }else{
              $(this).find('.txt').text('Fermer');
           }
          // e.preventDefault();
    });


  

    /*************/
    /* OUVERTURE / FERMETURE DES AUTRES TELECHARGMEMENTS / ARCHIVES */
    /*************/
    $('.special--autre-js').hide();
    $('.js-action-open-other').click(function(e){
          if($(this).attr('aria-expanded') == 'false'){
              $(this).parent().next().slideDown(500);
               var offsetTop =  $(this).parent().next().offset().top - 80;
               $('html, body').stop().animate({ 
                  scrollTop: offsetTop
              }, 500);
              $(this).attr('aria-expanded', 'true');
              $(this).html('<i class="icon-icon-close"></i>'+$(this).attr('data-txt-close'));
           }else{
              $(this).parent().next().slideUp(500);
              $(this).attr('aria-expanded', 'false');
              $(this).html('<i class="icon-icon-tobottom"></i>'+$(this).attr('data-txt-open'));
           }
           e.preventDefault();
    });
    

    /*************/
    /* SUBMENU SCROLLING = FIXED */
    /*************/
  
    if($('#submenu-js').length){
      $(window).scroll(function () {
        action_on_scroll_page();
      });
      //  $( window ).resize(function() {
      //      position_top_sub_menu = $("#submenu-js").offset().top;
      // });
    }
  

  function active_fixed_sub_menu(){
    $("body").addClass('to_fixed_menu'); 
  }

  function remove_fixed__sub_menu(){
    $("body").removeClass('to_fixed_menu');
  }


  function action_on_scroll_page(){

       if ($(window).scrollTop() > position_top_sub_menu){
          active_fixed_sub_menu();
        }else{
          remove_fixed__sub_menu();
        }
 }

   /*************/
    /* SUBMENU SCROLLING = ACTIVE + LINK TO SECTION // SIMPLEMENT POUR SINGLE ACTIVITY*/
    /*************/
  function scroll_to_section(href_dest){
    var variable = 0;
      //  if (href == "#realisations")  variable = 170;
    var offsetTop = href_dest === "#" ? 0 : $(href_dest).offset().top-topMenuHeight+1-variable;
    $('html, body').stop().animate({ 
        scrollTop: offsetTop
    }, 500);
  }
  if($('.single #submenu-js').length){
     // Cache selectors
  var lastId,
      topMenu = $("#submenu-js"),
      topMenuHeight = topMenu.outerHeight()+15,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
      });
    // PODOM MOBILE HERE
    // if(l_window < 769){
    //     topMenuHeight = $('#masthead').outerHeight();
    // }

  // Bind click handler to menu items
  menuItems.click(function(e){
    var href = $(this).attr("href");
    scroll_to_section(href);
    e.preventDefault();
  });

 

  // var other_link =  $('.Intro-Link-js, .intro-link-js')
  // other_link.click(function(e){
  //   var href = $(this).attr("href"),
  //       offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
  //     $('html, body').stop().animate({ 
  //         scrollTop: offsetTop
  //     }, 300);
  //     e.preventDefault();
  // });

  // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight;
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
      variable_top = 0;
      //if($(this).attr('id') == "realisations") variable_top = 170;else variable_top = 0;
       if ($(this).offset().top - variable_top < fromTop)
        return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems
           .parent().removeClass("active_menu")
           .end().filter("[href='#"+id+"']").parent().addClass("active_menu");
     }                  
  });

 } 


   /*************/
    /* GESTION D'AFFICHAGE DES BREVES  */
  /*************/

  var button_open_brief = $('.js-BtnOpenBrief');
  var BlockAllBrief = $('.AllBrief');
  var CacheOpen = $('.AllBrief-Cache');
  // var block_aside_inner = $('.Register-Block');
  // if(l_window < LARGEUR_MAX_MOBILE+1){
  //   block_aside_inner.hide();
  // }
  button_open_brief.click(function() {
    l_window = parseInt($(window).width());
     if($(this).attr('aria-expanded') == 'false'){
        BlockAllBrief.addClass('to_open');
         CacheOpen.addClass('to_open').fadeIn(500);
        $(this).attr('aria-expanded', 'true');
     }else{
        BlockAllBrief.removeClass('to_open');
        CacheOpen.fadeOut(500, function(){$(this).removeClass('to_open');});
        $(this).attr('aria-expanded', 'false');
     }

    if(l_window > LARGEUR_MAX_MOBILE+1){

    }else{
     // block_aside_inner.slideToggle(500);
    }
  });

   var ButtonCloseBrief = $('.btn-closebriefs-js, .AllBrief-Cache');
   ButtonCloseBrief.click(function() {
      CacheOpen.fadeOut(500, function(){$(this).removeClass('to_open');});
      BlockAllBrief.removeClass('to_open');
      button_open_brief.attr('aria-expanded', 'false');
   });
    

  /*************/
    /* SCROLLBAR - BREVES */
  /*************/


  if($('.myscrollbar').length){
    var el = document.querySelector('.myscrollbar');
    SimpleScrollbar.initEl(el);
  } 


  /*************/
    /* DIAPORAMA - DANS PAGE ACTIVITE */
  /*************/


   $('.GalleryImage-js').slick({
     slidesToShow: 1,
     infinite: true,
     slidesToScroll: 1,
      dots: false,
      arrows:true,
      adaptiveHeight: true,
      responsive: [
      {
        breakpoint: 769, // < 769
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows:true
        }
      }
    ]
  });



    /*************/
    /* SLIDER - HOME - AGENDA // PB BOUCLE */
    /*************/

  function EnterTextButton(currentSlide){
    
    var NbElt = $('.EventHome-Slider-js .slick-track .EventResume-Item').length;
    // suivant 
   if(parseInt(currentSlide+1) != NbElt){
     var day_next_event = $('.EventHome-Slider-js .slick-track .EventResume-Item').eq(currentSlide+1).attr('data-date-day');
     var monthyear_next_event = $('.EventHome-Slider-js .slick-track .EventResume-Item').eq(currentSlide+1).attr('data-date-month');
     var content_btn_next = '<span class="day">'+day_next_event+'</span><span class="month_year">'+monthyear_next_event+'</span>';
     $('.txt_next_change').html(content_btn_next);
    }

     // précédent 
     if(currentSlide != 0){
        var day_prev_event = $('.EventHome-Slider-js .slick-track .EventResume-Item').eq(currentSlide-1).attr('data-date-day');
        var monthyear_prev_event = $('.EventHome-Slider-js .slick-track .EventResume-Item').eq(currentSlide-1).attr('data-date-month');
        var content_btn_prev = '<span class="day">'+day_prev_event+'</span><span class="month_year">'+monthyear_prev_event+'</span>';
        $('.txt_prev_change').html(content_btn_prev);
     }
  } 

   $('.EventHome-Slider-js').on('init', function(event, slick){
      var currentSlide = $(this).find('li.slide.slick-current');
      EnterTextButton(0);
  });

   $('.EventHome-Slider-js').slick({
     slidesToShow: 1,
     infinite: false,
     slidesToScroll: 1,
      dots: false,
     // arrows:false,
      nextArrow: '.next_txt',
      prevArrow: '.prev_txt'
  });


  
   
  

   $('.EventHome-Slider-js').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      EnterTextButton(nextSlide);
      if(nextSlide > currentSlide) $('.EventHome-Slider').removeClass('to_next to_prev').addClass('to_next');else $('.EventHome-Slider').removeClass('to_next to_prev').addClass('to_prev');
   });
    

 });